<template>
	<div class="">
		<div></div>
		<div id="questionnaire-list-accordion" class="accordion">
			<collapsable
				:title="section.title"
				accordion="#questionnaire-list-accordion"
				:key="index"
				:show="false"
				v-for="(section, index) in sections"
			>
				<template slot="header_content">
					<div class="badge badge--sm badge--primary">{{numSubmissions(section)}}</div>
				</template>

				<template slot="content">
					<list-item v-for="location in section.locations" :key="location.id" @click="openLocation(location)">
						<template slot="title">
							<div>
								<h5>{{location.name}}</h5>
								<h6>{{getLocationSubtitle(location)}}</h6>
							</div>
						</template>
						<template slot="center">
							<div class="badge badge--sm badge--primary">{{getLocationNumSubmissions(location)}}</div>
						</template>
					</list-item>

					<div v-if="!section.locations.length" class="flex-row">
						<h6 class="flex-table--cell text-light">No submissions</h6>
					</div>
				</template>
			</collapsable>
		</div>
	</div>
</template>

<script>
	import Collapsable from "../ListComponent/Collapsable";
	import GalleryViewComponent from "../general_components/GalleryViewComponent";
	export default {
		name: "QualityAssuranceQuestionnaireSections",
		components: {GalleryViewComponent, Collapsable},
		props: {
			sections: {
				required: true
			},
			show_url: {
				required: true,
				type: String
			}
		},
		methods: {
			numSubmissions(section){
				let num_subs = 0;

				section.locations.forEach(location => {
					num_subs += location.question_answers_groups.length;
				});
				return num_subs;
			},

			getLocationSubtitle(location){
				if (location.level.trim() && location.type)
					return 'Level: ' + location.level + ' / Type: ' + location.type;

				if (location.level.trim())
					return 'Level: ' + location.level
				else if (location.room_type)
					return 'Type: ' + location.type

				return null;
			},

			getLocationNumSubmissions(location){
				return location.question_answers_groups.length;
			},

			openLocation(location){
				window.location.href = this.show_url.replace('?', location.id);
			}
		},
	}
</script>